// TODO keep this file in manual sync with backend until #16429 is resolved

export interface OpenAITupleValue {
    keyword: string | null;
    value1: string | null;
    value2: string | null;
    // Missing until the job has run (or when it will be regenerated in the next run)
    state?: "done" | "failed";
    seq?: number;
    /** Run that wrote the row. Rows from v1.14.2 have none. */
    runId?: string;
    /** Server time the run started. */
    runAt?: number;
}

export interface OpenAIEditRequest {
    articleId: string;
    /** Path B only. Persisted before the outline is built. */
    improveGoal?: "polish" | "fill" | "rewrite";
    /** Rewrite: checked headings, h2-{index} in the loaded outline. */
    sectionUids?: string[];
    /** Retry one failed path-B block. Other proposals stay. */
    retryProposalId?: string;
}

export type OpenAIPolishRequest = {
    articleId: string;
}

export type OpenAIEditResponse = Record<string, never>;

export type OpenAiCompletionType = "meta" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "question";

export interface OpenAICompletionData {
    state: "ok" | "failed";
    count: number;
    touch: number;
    mode?: "whole" | "parts";
    /** Run that reset this part document. */
    runId?: string;
}

export type OpenAiPolishData = {
    timestamp: number;
    value?: string;
    error?: any;
}

export enum OpenAiExpandPartType {
    FROM_HEADING = "FROM_HEADING",
    FROM_USER_INPUT = "FROM_USER_INPUT",
    FROM_QUESTION = "FROM_QUESTION",
}

type OpenAiExpandPartDataFromHeading = {
    type: OpenAiExpandPartType.FROM_HEADING;
    data: {
        heading: string;
    };
};

type OpenAiExpandPartDataFromUserInput = {
    type: OpenAiExpandPartType.FROM_USER_INPUT;
    data: {
        userInput: string;
    };
};

type OpenAiExpandPartDataFromQuestion = {
    type: OpenAiExpandPartType.FROM_QUESTION;
    data: {
        question: string;
    };
};

export type OpenAiExtendPartRequest = {
    articleId: string;
    part: string;
    uid: number;
} & (
    | OpenAiExpandPartDataFromHeading
    | OpenAiExpandPartDataFromUserInput
    | OpenAiExpandPartDataFromQuestion
);

export interface OpenAiExtendPartResponse {
    valueId: string;
}

interface OpenAiExtendPartDataInterface {
    created_at: number;
    state: "running" | "done" | "failed";
    value: string;
    used: boolean;
    discarded: boolean;
}

export type OpenAiExtendPartData = OpenAiExtendPartDataInterface &
    (
        | OpenAiExpandPartDataFromHeading
        | OpenAiExpandPartDataFromUserInput
        | OpenAiExpandPartDataFromQuestion
    );

export interface OpenAiExtendPartDataWithIdInterface extends OpenAiExtendPartDataInterface {
    valueId: string;
}

export type OpenAiExtendPartDataWithId = OpenAiExtendPartDataWithIdInterface &
    (
        | OpenAiExpandPartDataFromHeading
        | OpenAiExpandPartDataFromUserInput
        | OpenAiExpandPartDataFromQuestion
    );
